import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { palette } from '../../foundation/utils.js';

let _ = t => t,
  _t;
const Text = styled(Typography)(_t || (_t = _`
  color: ${0};
`), props => props.color && palette(props.color));

export { Text };
